<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)" v-loading="loading">
      <div class="  " v-if="current_booking" style="padding: 20px">
        <div class="">
          <h4 class="card-title">
            Transfer {{ current_booking.total_passengers }} Passengers
          </h4>
        </div>
        <div class="">
          <div class="row">
            <div class="col-md-12" v-if="booking">
              <div>
                Current Booking Schedule: <br />{{ booking.booking_date }} -
                {{ booking.formatted_time }}
                (
                {{ booking.route.code }})
                <span>{{ booking.status_label }}</span>
              </div>
            </div>

            <div class="col-md-8">
              <booking-transfer-list
                :booking="booking"
                @update="selected_tickets = $event"
                :update="update_transfer"
              ></booking-transfer-list>
            </div>
            <div class="col-md-4">
              <br /><br />
              <div>Select New Schedule</div>
              <hr />
              <div class="form-group">
                <label>Booking Date</label>
                <ValidationProvider
                  name="booking_date"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <el-date-picker
                    v-model="form.booking_date"
                    type="date"
                    placeholder="Pick a day"
                    class="form-group"
                    :class="[
                      { 'has-danger': failed },
                      { 'has-success': passed },
                    ]"
                  >
                  </el-date-picker>
                  <br /><span class="error-text" v-if="failed"
                    >Booking Date is required</span
                  >
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label>Time</label>
                <ValidationProvider
                  name="route"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <el-select
                    v-model="form.time"
                    placeholder="Select"
                    filterable
                    class="form-group"
                    :class="[
                      { 'has-danger': failed },
                      { 'has-success': passed },
                    ]"
                  >
                    <el-option
                      :value="trip.time"
                      :label="trip.formatted_time"
                      v-for="trip in trips"
                      :key="trip.time"
                      >{{ trip.formatted_time }}</el-option
                    > </el-select
                  ><br />
                  <span class="error-text" v-if="failed">Time is required</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <div class="text-right">
              <div v-if="selected_booking" style="font-size: 15px;font-weight: bold;">Capaciity : {{ selected_booking.capacity }} | Booked Tickets: {{ selected_booking.total_completed_tickets }} | Available: {{ selected_booking.capacity - selected_booking.total_completed_tickets }}</div>
              <div v-if="selected_booking && selected_booking.is_fully_booked">
                <el-alert type="error" :closable="false">FULLY BOOKED</el-alert>
              </div>
              <div v-else>
                <el-button
                  type="warning"
                  native-type="button"
                  plain
                  :disabled="!form.booking_id || !selected_tickets.length"
                  @click="handleTransferSelectedPassengers"
                  style="margin-bottom: 10px"
                  >TRANSFER {{ selected_tickets.length }} PASSENGERS
                  ONLY</el-button
                ><br />
                <el-button
                  type="primary"
                  native-type="submit"
                  plain
                  :disabled="!form.booking_id || selected_tickets.length"
                  >TRANSFER ALL</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import { Booking } from "@/resources/booking";
import moment from "moment";

import Swal from "sweetalert2";
import BookingTransferList from "./BookingTransferList.vue";

extend("required", required);

export default {
  components: { BookingTransferList },
  props: ["booking"],
  data() {
    return {
      form: {
        booking_date: new Date(),
        time: null,
        booking_id: null,
      },
      trips: [],
      selected_booking: null,
      selected_tickets: [],
      update_transfer: 0,
      current_booking: null,
      loading: false,
    };
  },
  watch: {
    booking: function () {
      if (this.booking) {
        this.form = {
          booking_date: this.booking.booking_date,
          time: null,
        };
        this.getTrips();
      }
    },
    "form.booking_date": function () {
      this.getTrips();
    },
    "form.time": function () {
      if (this.form.time) this.getBooking();
    },
  },
  created: function () {
    if (this.booking) {
      this.current_booking = Object.assign({}, this.booking);
      this.form = {
        booking_date: this.booking.booking_date,
        route_code: this.booking.route.code,
        time: null,
      };
    }
  },
  methods: {
    searchTime() {
      this.getTrips();
    },
    clearData() {
      this.form.booking_id = null;
    },
    handleTransferSelectedPassengers() {
      this.submit(true);
    },
    async submit(specific_passengers) {
      if (specific_passengers && this.selected_tickets.length > 20) {
        this.$notify({
          type: "danger",
          title: "Attention",
          text:
            "You can only transfer 20 Passengers at a time. You have selected " +
            this.selected_tickets.length +
            " passengers",
        });
        return;
      }
      let message = specific_passengers
        ? "Transfer Selected Passengers."
        : "Transfer All Passengers.";
      let remarks =
        "You are about to transfer " +
        this.selected_tickets.length +
        " passengers";
      if (!specific_passengers) {
        remarks =
          "Please be advised that transferring passengers, particularly when there are more than 20, may take some time. Some passengers may not be transferred if the destination trip is already at full capacity ";
      }

      const { value: res } = await Swal.fire({
        title: message,
        text: remarks + ". This action cannot be undone. Proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-info",
        buttonsStyling: false,
        input: !specific_passengers ? "text" : null,
        inputPlaceholder: !specific_passengers
          ? 'Type "transfer" to confirm'
          : "",
        inputValidator: (value) => {
          if (!specific_passengers && value !== "transfer") {
            return 'You must type "transfer" to confirm';
          }
        },
      });

      if (!res || (!specific_passengers && res !== "transfer")) return;

      this.$loading = true;
      if (specific_passengers) {
        this.form.selected_tickets = this.selected_tickets;
        this.form.transfer = "selected";
      } else {
        this.form.selected_tickets = null;
        this.form.transfer = "all";
      }

      this.loading = true;

      Booking.transferPassengers(this.booking.id, this.form)
        .then((result) => {
          this.current_booking = result.data.booking;
          if (!specific_passengers) {
            this.$notify({
              type: "success",
              title: "Success",
              text: "All passengers have been transferred",
            });
            this.$emit("save", true);
          } else {
            this.$notify({
              type: "success",
              title: "Success",
              text:
                this.selected_tickets.length +
                " passengers have been transferred",
            });
            this.update_transfer += 1;
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading = false;
          this.loading = false;
        });
    },
    getBooking() {
      if (!this.form.booking_date) return;
      if (!this.form.time) return;

      this.$loading = true;
      Booking.getBooking({
        for_transfer: true,
        date: this.$moment(this.form.booking_date).format("YYYY-MM-DD"),
        route_code: this.booking.route.code,
        time: this.form.time,
      })
        .then((result) => {
          this.selected_booking = result.data.booking;
          this.form.booking_id = result.data.booking.id;
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },

    getTrips() {
      this.trips = [];
      if (!this.form.booking_date) return;
      this.$loading = true;
      this.form.time = null;
      Booking.getTrips({
        date: this.$moment(this.form.booking_date).format("YYYY-MM-DD"),
        route_code: this.booking.route.code,
        per_page: 999,
        time_only: true,
      })
        .then((result) => {
          if (result.data.trips) this.trips = result.data.trips;
          if (this.trips.length) this.form.time = this.trips[0].time;
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },
  },
};
</script>

<style></style>
